import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { siteConfig } from '@/constants/site'
import SiteHeader from '@/components/landing/site-header'
import FilmStage from '@/components/landing/film/film-stage'
import SpecMarquee from '@/components/landing/spec-marquee'
import MonoblockSection from '@/components/landing/monoblock-section'
import FinishesSection from '@/components/landing/finishes-section'
import AtelierSection from '@/components/landing/atelier-section'
import CommissionSection from '@/components/landing/commission-section'
import SiteFooter from '@/components/landing/site-footer'

const Home: FC = (): ReactNode => {
    return (
        <>
            <SiteHeader />
            <Layout>
                <Seo ogImage={siteConfig.ogImage} />
                <FilmStage />
                <SpecMarquee />
                <MonoblockSection />
                <FinishesSection />
                <AtelierSection />
                <CommissionSection />
            </Layout>
            <SiteFooter />
        </>
    )
}

export default Home
